// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
// Utilities
import { compositeKeyFromStringArray } from "@ms/uno-utilities/lib/local/StringUtilities";
import { Temporal } from "temporal-polyfill-lite";
export class ClearAccessTokenAction extends TypedAction(ActionType.ClearAccessTokenAction) {
    loggingData() {
        return {
            scopes: compositeKeyFromStringArray(this.scopes)
        };
    }
    constructor(scopes){
        super(), this.scopes = scopes;
    }
}
export class FetchAccessTokenAction extends TypedAction(ActionType.FetchAccessTokenAction) {
    loggingData() {
        return {
            actionId: this.actionId,
            scopes: compositeKeyFromStringArray(this.scopes)
        };
    }
    constructor(actionId, scopes, claims){
        super(), this.actionId = actionId, this.scopes = scopes, this.claims = claims, this.isTrackingEnabled = true;
    }
}
export class FetchAccessTokenFailedAction extends TypedAction(ActionType.FetchAccessTokenFailedAction) {
    loggingData() {
        return {
            actionId: this.actionId,
            scopes: compositeKeyFromStringArray(this.scopes)
        };
    }
    constructor(actionId, scopes, claims, error){
        super(), this.actionId = actionId, this.scopes = scopes, this.claims = claims, this.error = error, this.isTrackingEnabled = true;
    }
}
export class FetchAccessTokenSucceededAction extends TypedAction(ActionType.FetchAccessTokenSucceededAction) {
    loggingData() {
        return {
            actionId: this.actionId,
            scopes: compositeKeyFromStringArray(this.scopes),
            expiry: this.expiry ? Temporal.Instant.fromEpochMilliseconds(this.expiry.getTime()).toString() : "null"
        };
    }
    constructor(actionId, scopes, accessToken, expiry, claims){
        super(), this.actionId = actionId, this.scopes = scopes, this.accessToken = accessToken, this.expiry = expiry, this.claims = claims, this.isTrackingEnabled = true;
    }
}
